console.log("call JS");

function reset () {
    console.log("call");
}
